var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-529.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29)-Widgets/3)-Statistics/9)-Sales-2-Copy-4",
    transform: "translate(516.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy-9",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-employee-207640",
    transform: "translate(10.000000, 9.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0111607,4.96875 C15.0111607,7.7188058 12.6674107,9.9374442 11.0423549,9.9374442 C9.32354911,9.9374442 7.07354911,7.71858259 7.07354911,4.96875 C7.07354911,2.2186942 8.54229911,5.58035714e-05 11.0423549,5.58035714e-05 C13.5424107,5.58035714e-05 15.0111607,2.21891741 15.0111607,4.96875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5111607,15.65625 C21.5111607,13.5313616 14.8236607,11.1561942 14.8236607,11.1561942 L12.5111049,16.0625558 L11.4798549,13.5939174 L11.8861719,12.8752232 L12.6986161,11.5001674 L9.51128348,11.5001674 L10.3237277,12.8752232 L10.7300446,13.5939174 L9.69879464,16.0625558 L7.35504464,11.1561942 C7.35504464,11.1561942 0.667544643,13.5311384 0.667544643,15.65625 L0.0426004464,25 L3.79254464,25 L3.94883929,22.3436384 L4.16769531,19.6249442 L4.38655134,22.3436384 L4.54284598,25 L17.917846,25 L18.0741406,22.3436384 L18.2929967,19.6249442 L18.5118527,22.3436384 L18.6681473,25 L22.1680915,25 L21.5111607,15.65625 Z",
    id: "Path"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRm);
export default __webpack_public_path__ + "static/media/RM.ed30bd9f302a21428c7e9018a8d86154.svg";
export { ForwardRef as ReactComponent };